import { backendFetch } from './apiUtils';

export const getUsersSkillsList = async (skip, amount, tableSort, filter = {}) => {
  const sort = {};
  if (tableSort?.direction) {
    sort.sortColumn = tableSort.currentKey;
    sort.sortDirection = tableSort.direction;
  }

  const response = await backendFetch({
    url: 'skillMatrix/users',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filter, skip, amount, ...sort }),
    },
  });

  return response;
};

export const getUsersSkills = async (id) => {
  const response = await backendFetch({
    url: `skillMatrix/user/${id}`,
    method: 'GET',
  });
  if (response[0] === undefined) {
    throw new RangeError('Not found');
  }

  return response[0];
};

export const putUsersSkills = async (user) => {
  const response = await backendFetch({
    url: `skillMatrix/user`,
    method: 'put',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(user),
    },
  });

  if (response[0]?.ErrorMessage) {
    throw new Error(response[0].ErrorMessage);
  }

  return response[0];
};

export const getUsersSkillsAudit = async (id) => {
  const response = await backendFetch({
    url: `skillMatrix/audit/${id}`,
    method: 'GET',
  });

  return response?.map((line, idx) => ({ ...line, idx }));
};
